import React, { useEffect, useState } from 'react';
import LogoLight from "../../asset/logo_light.png";
import './ProfileSettings.css';

const translations = {
    english: {
        editProfile: 'Edit Profile',
        personalInfo: 'Personal info',
        userName: 'User Name',
        companyName: 'Company Name',
        email:'Email',
        submit:'Submit',
           
    },
    german: {
      editProfile: 'Profil Bearbeiten',
        personalInfo: 'Persönliche Informationen',
        userName: 'Benutzername',
        companyName: 'Unternehmensname',
        email:'Email',
        submit:'Speichern',
      
    },
    czech: {
      editProfile: 'Upravit profil',
        personalInfo: 'Osobní údaje',
        userName: 'Uživatelské jméno',
        companyName: 'Název společnosti',
        email:'Email',
        submit:'Submit',       
    },
    italian: {
      editProfile: 'Modifica profilo',
        personalInfo: 'Informazioni personali',
        userName: 'Nome utente',
        companyName: 'Nome della società',
        email:'E-mail',
        submit:'Invia',     
    },
  };


function ProfileSettings() {
    const [users, setUsers] = useState([]);
    const [userName, setUserName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem('language') || 'english');
    const [success, setSuccess] = useState(false);
    const config=require( '../../config.js');
    useEffect(() => {
        const fetchUsers = async () => {
            const storedEmail = localStorage.getItem('email');
            setEmail(storedEmail);
            try {
                const response = await fetch(config.env.API_BASE_URL+'/api/users/me', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    if (data) {
                        localStorage.setItem('user', JSON.stringify(data));
                        setUsers([data]);
                        setUserName(data.name);
                        setCompanyName(data.companyName);
                    } else {
                        console.error('No matching user found');
                    }
                } else {
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };
        fetchUsers();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const user = {
            name: userName,
            companyName: companyName,
            email: email
        };
        try {
            const response = await fetch(config.env.API_BASE_URL+`/api/users/?email=${email}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(user)
            });
            if (response.ok) {
                const updatedUser = await response.json();
                setUsers([updatedUser]);
                setSuccess(true);
            } else {
                console.error('Failed to update user');
            }
        } catch (error) {
            console.error('Error updating user:', error);
        }
    };

    useEffect(() => {
        if (success) {
            alert('Updated successfully');
            setSuccess(false); // Reset success state
        }
    }, [success]);

    return (
        <section className='mt-5'>
            {users.map((value, index) => (
                <div key={index}>
                    <div className="container">
                        <img src={LogoLight} alt='logo' width={300} />
                        <h1 className="text-secondary mt-5">{translations[currentLanguage].editProfile}</h1>
                        <hr />
                        <div className="row">
                            <div className="personal-info my-5">
                                <h3>{translations[currentLanguage].personalInfo}</h3>
                                <form className="form-horizontal text-start" role="form" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label className="col-lg-3 control-label">{translations[currentLanguage].userName}:</label>
                                        <div className="col-lg-8 mt-2">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={userName}
                                                onChange={(e) => setUserName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label className="col-lg-3 control-label">{translations[currentLanguage].companyName}:</label>
                                        <div className="col-lg-8 mt-2">
                                            <input
                                                className="form-control"
                                                type="text"
                                                value={companyName}
                                                onChange={(e) => setCompanyName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group mt-3">
                                        <label className="col-lg-3 control-label">{translations[currentLanguage].email}:</label>
                                        <div className="col-lg-8 mt-2">
                                            <input className="form-control" disabled type="text" value={email} />
                                        </div>
                                    </div>
                                    <div className="form-group mt-5">
                                        <div className="col mt-2">
                                            <input className="form-control bg-primary text-white" type="submit" value={translations[currentLanguage].submit} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <hr />
                    </div>
                </div>
            ))}
        </section>
    );
}

export default ProfileSettings;
